var module = angular.module('octopusApp.projects');

module.directive('channelLabel', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      project: '=project',
      channels: '=channels',
      channelId: '=channelId'
    },
    template: '<span class="label label-primary">{{name}}</span>',
    controller: function($scope, octopusRepository) {
      $scope.name = null;
      if($scope.channels){
        setChannelName($scope.channels);
      } else {
        octopusRepository.Projects.getChannels($scope.project).then(setChannelName);
      }

      function setChannelName(channels){
        if(channels.Id){
          $scope.Name = channels.Name;
        } else if (channels.Items !== undefined && channels.Items.length > 1) {
          $scope.name = channels.Items.filter(function (channel) {
            return channel.Id === $scope.channelId;
          })[0].Name;
        }
      }
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/channel_label.js
// module id = 8614193480845669
// module chunks = 1